module.exports = __webpack_public_path__ + "static/media/pos_device_off.1b7c9df8.svg";